/*
 * Copyright © 2020-2026 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: yingongjing
 * @LastEditTime: 2026-02-09 17:26:59
 */
export interface TechFeature {
  id: number
  title: string
  description: string
}

export const TECH_FEATURES: TechFeature[] = [
  {
    id: 1,
    title: '分辨率检测',
    description: '原图像素验证，防止二次翻拍或低质量修改图像。'
  },
  {
    id: 2,
    title: '数字防伪码',
    description: '基于区块链加密技术，为每张照片生成唯一数字身份指纹。'
  },
  {
    id: 3,
    title: '异常检测',
    description: '集成AI智能识别，精准判定是否使用各类修改工具及模拟器。'
  },
  {
    id: 4,
    title: '时间戳验证',
    description: '直连国家授时中心，提供权威时间戳同步，确保记录不可篡改。'
  },
  {
    id: 5,
    title: 'GPS定位',
    description: '经纬度多重验证，结合基站定位与卫星信号，真实地理围栏。'
  }
]
